export const eventChartDataQueryKeys = {
  all: ["eventChartData"] as const,
  data: () => [...eventChartDataQueryKeys.all] as const
} as const;
